import React from 'react';
import rCss from '../../../Styles/reports.module.css'
import { observer } from "mobx-react-lite";
import type { KnownTracker } from "../../../lib/KnownTrackers";


export const KnownTrackerView = observer(({ knownTracker }: { knownTracker?: KnownTracker; }) => {
	if (knownTracker == null) return null;
	const { ghosteryId, ghosteryOrganizationName, whenAddedToGhostery, disconnectMeName, whenAddedToDisconnectMe
	} = knownTracker;
	return (<>
		{disconnectMeName != null && whenAddedToDisconnectMe != null ? (
			<div className={rCss.TrackerLineElement}>
				<span className={rCss.TrackerDbNameSpan}>DisconnectMe</span>&#32; added as&#32;
				<span className={rCss.TrackerOrgNameSpan}>{disconnectMeName}</span>
				{whenAddedToDisconnectMe === "2015-10-13T19:06:27.000Z" ? " in its initial database (Oct 13, 2015)" :
					` on ${new Date(whenAddedToDisconnectMe).toLocaleDateString("en", { month: 'short', day: 'numeric', year: 'numeric' })}`}
			</div>) : null}
			{ghosteryId != null && ghosteryOrganizationName != null && whenAddedToGhostery != null ? (
				<div className={rCss.TrackerLineElement}>
				<span className={rCss.TrackerDbNameSpan}>Ghostery</span>&#32; added as&#32;<span className={rCss.TrackerOrgNameSpan}>{ghosteryOrganizationName}</span>&#32;(ID: {ghosteryId}) {whenAddedToGhostery === "2023-02-20T19:33:05.000Z" ? " in its initial database (Feb 20, 2023)" :
					` on ${new Date(whenAddedToGhostery).toLocaleDateString("en", { month: 'short', day: 'numeric', year: 'numeric' })}`}
			</div>
		) : null}
	</>);
});
